// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createVendorPurchaseOrders = (client) => ({
    /**
     * `POST /vendor/purchase-orders/:id/approve`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorPurchaseOrdersIdApproveCreate
     * @source apps/backend/src/api/vendor/purchase-orders/[id]/approve/route.ts
     */
    approve: (id, body, query, headers) => client.fetch(buildPath("/vendor/purchase-orders/:id/approve", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/purchase-orders/:id/cancel`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorPurchaseOrdersIdCancelCreate
     * @source apps/backend/src/api/vendor/purchase-orders/[id]/cancel/route.ts
     */
    cancel: (id, body, query, headers) => client.fetch(buildPath("/vendor/purchase-orders/:id/cancel", [id]), { method: "POST", body, query, headers }),
    /**
     * `GET /vendor/purchase-orders`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorPurchaseOrdersList
     * @source apps/backend/src/api/vendor/purchase-orders/route.ts
     */
    list: (query, headers) => client.fetch("/vendor/purchase-orders", { method: "GET", query, headers }),
    /**
     * `POST /vendor/purchase-orders/:id/refund`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorPurchaseOrdersIdRefundCreate
     * @source apps/backend/src/api/vendor/purchase-orders/[id]/refund/route.ts
     */
    refund: (id, body, query, headers) => client.fetch(buildPath("/vendor/purchase-orders/:id/refund", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/purchase-orders/:id/reject`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorPurchaseOrdersIdRejectCreate
     * @source apps/backend/src/api/vendor/purchase-orders/[id]/reject/route.ts
     */
    reject: (id, body, query, headers) => client.fetch(buildPath("/vendor/purchase-orders/:id/reject", [id]), { method: "POST", body, query, headers }),
    /**
     * `GET /vendor/purchase-orders/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorPurchaseOrdersIdGet
     * @source apps/backend/src/api/vendor/purchase-orders/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/vendor/purchase-orders/:id", [id]), { method: "GET", query, headers }),
    /**
     * `GET /vendor/purchase-orders/:id/document/signed-url`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorPurchaseOrdersIdDocumentSignedUrlGet
     * @source apps/backend/src/api/vendor/purchase-orders/[id]/document/signed-url/route.ts
     */
    retrieveDocumentSignedUrl: (id, query, headers) => client.fetch(buildPath("/vendor/purchase-orders/:id/document/signed-url", [id]), { method: "GET", query, headers }),
    /**
     * `POST /vendor/purchase-orders/:id/mark-paid`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorPurchaseOrdersIdMarkPaidCreate
     * @source apps/backend/src/api/vendor/purchase-orders/[id]/mark-paid/route.ts
     */
    updateMarkPaid: (id, body, query, headers) => client.fetch(buildPath("/vendor/purchase-orders/:id/mark-paid", [id]), { method: "POST", body, query, headers }),
});
//# sourceMappingURL=purchase-orders.js.map